<ng-template #rt let-r="result" let-t="term">
  <div *ngIf="!r.otherSearch" class="row g-0 align-items-center">
    <div class="col d-flex align-items-center">
      <fa-icon class="h5 mb-0 text-primary" [icon]="categoryIcon(r.entityTypeId)" [fixedWidth]="true"></fa-icon>
      <div class="ms-3 text-truncate flex-fill">
        <div class="text-muted">{{r.category}}</div>
        <div class="text-truncate">
          <ngb-highlight [result]="r.description" [term]="t"></ngb-highlight>
        </div>
        <div class="text-truncate" *ngFor="let detail of r.details">
          <ngb-highlight [result]="detail" [term]="t"></ngb-highlight>
        </div>
      </div>
      <fa-icon class="text-primary ms-2" [icon]="['fas', 'chevron-right']" [fixedWidth]="true"></fa-icon>
    </div>
  </div>
  <div *ngIf="r.otherSearch" class="row g-0 align-items-center">
    <div class="col text-primary">
      Don't see what you're searching for?
    </div>
    <div class="col-auto">
      <fa-icon class="text-primary" [icon]="['fas', 'chevron-right']" [fixedWidth]="true"></fa-icon>
    </div>
  </div>
</ng-template>

<div>
  <div id="goToInput" class="inner-addon" [ngClass]="{'dark': dark}">
    <fa-icon [icon]="faSearch"></fa-icon>
    <input type="text" class="form-control form-control-lg dark" [placeholder]="placeholder"
      [(ngModel)]="goToService.searchValue" [ngbTypeahead]="goToService.typeahead" (focus)="onFocus($event)"
      (blur)="onBlur()" [resultTemplate]="rt" [inputFormatter]="goToService.selectionFormatter" [placement]="placement"
      (selectItem)="navigate($event)" />
  </div>
  <div id="goToLoading" ngbDropdown [open]="true" display="static" [placement]="placement" *ngIf="goToService.searching">
    <button ngbDropdownToggle class="btn btn-link d-block w-100 no-toggle"></button>
    <div ngbDropdownMenu class="w-100">
      <div class="dropdown-item-text text-center text-primary">
        <fa-icon [icon]="['fal', 'spinner-third']" [spin]="true" size="lg" [fixedWidth]="true"></fa-icon>
      </div>
    </div>
  </div>
  <div id="goToNoResults" ngbDropdown [open]="true" display="static" [placement]="placement" *ngIf="goToService.noResults">
    <button ngbDropdownToggle class="btn btn-link d-block w-100 no-toggle"></button>
    <div ngbDropdownMenu class="typeahead-menu">
      <div class="dropdown-item-text pb-2">
        <dx-typeahead-empty [value]="goToService.searchValue"></dx-typeahead-empty>
      </div>
      <button class="dropdown-item" type="button" (click)="goToSearch()">
        <div class="row align-items-center">
          <div class="col text-primary">
            Go to search
          </div>
          <div class="col-auto">
            <fa-icon class="text-primary" [icon]="['fas', 'chevron-right']" [fixedWidth]="true"></fa-icon>
          </div>
        </div>
      </button>
    </div>
  </div>
  <div id="goToError" ngbDropdown [open]="true" display="static" [placement]="placement" *ngIf="goToService.searchingError">
    <button ngbDropdownToggle class="btn btn-link d-block w-100 no-toggle"></button>
    <div ngbDropdownMenu class="typeahead-menu">
      <div class="dropdown-item-text">
        <dx-generic-error></dx-generic-error>
      </div>
    </div>
  </div>
</div>
